export default {
  getGroupList: {
    method: 'get',
    url: '/api/v1/custom-management/customs'
  },
  deleteGroups: {
    method: 'delete',
    url: '/api/v1/custom-management/customs',
    mockData: {
      code: 200
    }
  },
  createGroup: {
    method: 'put',
    url: '/api/v1/custom-management/customs'
  },
  getRuleData: {
    method: 'get',
    url: '/api/v1/eventAttribute/eventAttribute',
    mockData: {
      code: 200,
      data: {}
    }
  },
  getRuleAssociate: {
    method: 'get',
    url: '/api/v1/associate/associateByKeyword',
    mockData: {
      code: 200,
      data: {}
    }
  }
}
